import React from 'react';

const TimeStayListings: React.FC = () => (
  <div style={{ padding: '24px', maxWidth: '600px', margin: '0 auto' }}>
    <h1 style={{ color: '#fff', marginBottom: '16px' }}>TimeStay</h1>
    <p style={{ color: '#9ca3af' }}>Listings and stay requests — wire to platform TimeStay API when ready.</p>
  </div>
);

export default TimeStayListings;
